import { useState, useEffect } from 'react';

const useInternetConnection = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [wasOffline, setWasOffline] = useState(false);

    useEffect(() => {
        // 온라인 상태 감지 함수
        const updateOnlineStatus = () => {
            const online = navigator.onLine;
            
            // 오프라인에서 온라인으로 복구된 경우 기록
            if (!isOnline && online) {
                setWasOffline(true);
                console.log('🌐 Internet connection restored');
            }
            
            // 온라인에서 오프라인으로 변경된 경우
            if (isOnline && !online) {
                console.log('🚫 Internet connection lost');
            }
            
            setIsOnline(online);
        };

        // 실제 네트워크 연결 상태를 확인하는 함수 (선택사항)
        const checkActualConnectivity = async () => {
            if (!navigator.onLine) {
                setIsOnline(false);
                return;
            }

            try {
                // 실제 네트워크 요청으로 연결 상태 확인
                const response = await fetch('/favicon.svg', {
                    method: 'HEAD',
                    cache: 'no-cache',
                    signal: AbortSignal.timeout(5000) // 5초 타임아웃
                });
                
                setIsOnline(response.ok);
            } catch (error) {
                console.log('🚫 Network check failed:', error.message);
                setIsOnline(false);
            }
        };

        // 이벤트 리스너 등록
        window.addEventListener('online', updateOnlineStatus);
        window.addEventListener('offline', updateOnlineStatus);

        // 페이지 포커스 시 실제 연결 상태 확인
        const handleFocus = () => {
            checkActualConnectivity();
        };
        
        window.addEventListener('focus', handleFocus);

        // 주기적으로 연결 상태 확인 (30초마다)
        const intervalId = setInterval(checkActualConnectivity, 30000);

        // 초기 상태 확인
        checkActualConnectivity();

        // 클린업 함수
        return () => {
            window.removeEventListener('online', updateOnlineStatus);
            window.removeEventListener('offline', updateOnlineStatus);
            window.removeEventListener('focus', handleFocus);
            clearInterval(intervalId);
        };
    }, [isOnline]);

    // wasOffline 상태를 리셋하는 함수
    const resetOfflineStatus = () => {
        console.log('resetOfflineStatus')
        setWasOffline(false);
    };

    return {
        isOnline,           // 현재 온라인 상태
        isOffline: !isOnline, // 현재 오프라인 상태
        wasOffline,         // 이전에 오프라인이었다가 복구된 상태
        resetOfflineStatus  // 오프라인 상태 리셋 함수
    };
};

export default useInternetConnection;
